import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PostDriverDayOffEntity } from '../../domain/entities/PostDriverDayOffEntity'

export class PostDriverDayOffModel extends PostDriverDayOffEntity {
  driverId?: number

  constructor(dataDto: PostDriverDayOffEntity) {
    super()
    mapEntityProperties<PostDriverDayOffModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id,
        startDate: toStartOfPlus3DayIso(dataDto.startDate),
        endDate: toEndOfPlus3DayIso(dataDto.endDate)
      }
    })
  }
}

function toStartOfPlus3DayIso(value?: Date | string | null) {
  if (!value) return undefined

  const d = new Date(value)
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0) - 3 * 3600 * 1000
  ).toISOString()
}

function toEndOfPlus3DayIso(value?: Date | string | null) {
  if (!value) return undefined

  const d = new Date(value)
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999) - 3 * 3600 * 1000
  ).toISOString()
}
